import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessagePopupComponent } from '../../components/popups/message-popup/message-popup.component';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PopupService {

  public static $closeAll = new BehaviorSubject<boolean>(false);

  constructor(private dialog: MatDialog) {
    PopupService.$closeAll.subscribe(shouldClose => {
      if (shouldClose) {
        this.dialog.closeAll();
        PopupService.$closeAll.next(false);
      }
    });
  }

  message(title: string, message: string) {
    this.dialog.open(MessagePopupComponent, { panelClass: 'ibex-popup', data: { title, message } });
  }

  error(title: string, message: string) {
    this.dialog.open(MessagePopupComponent, { panelClass: 'ibex-popup-error', data: { title, message } });
  }

  warn(title: string, message: string) {
    this.dialog.open(MessagePopupComponent, { panelClass: 'ibex-popup-warn', data: { title, message } });
  }
}
